export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'Phone',
    'RequestMessage'
  ],
  'requiredFields': {
    'default': [
      'CompanyRegistrationNo',
      'Company',
      'PostalCode'
    ],
    'consulting': [
      'CompanyRegistrationNo',
      'RequestTopic',
      'Company',
      'PostalCode'
    ],
    'offersGeneral': [
      'CompanyRegistrationNo',
      'RequestTopic',
      'Company',
      'PostalCode'
    ],
    'cooperation': [
      'CompanyRegistrationNo',
      'RequestTopic',
      'Company',
      'PostalCode'
    ],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic',
      'CompanyRegistrationNo'
    ],
    'other': [
      'PostalCode'
    ]
  }
}
